module.exports = __webpack_public_path__ + "img/down.feff5c4f.svg";